import { useToast } from '@marrafa-gioale/gymx-ui-web'
import { useEffect } from 'react'

import { connectToast } from '@/lib/toast'

/**
 * Collega `notify()` al `ToastProvider` del design system.
 *
 * Va montato **dentro** `<ToastProvider>`: fuori, `useToast()` restituisce lo
 * stub del design system e i messaggi finiscono in un avviso in console invece
 * che a schermo.
 *
 * È un file a sé e non una seconda esportazione di `@/lib/toast` perché lì vive
 * lo stato di modulo: un file che esporta un componente **e** dei valori perde
 * il fast refresh, e con esso la coda dei messaggi a ogni salvataggio.
 */
export function ToastBridge() {
  const toast = useToast()

  useEffect(() => {
    // La coda si svuota dentro l'effetto e non nel render: un `show` durante il
    // render aggiornerebbe lo stato del provider mentre lo si sta disegnando.
    connectToast(toast)
    return () => {
      connectToast(null)
    }
  }, [toast])

  return null
}
